var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaintainanceMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 465,
    height: 271,
    viewBox: "0 0 465 271",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9805_207545)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M151.06 114.72L146.99 106.18C155.51 97.43 151.99 88.32 144.35 72.38C136.71 56.44 129.26 44.31 110.09 53.44C89.79 63.12 102.68 83.91 110.24 99.76L124.24 127.5L151.06 114.72Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130.65 108.25C135.864 108.666 141.091 107.627 145.75 105.25C153.96 101.13 151.87 88.32 144.28 72.39C136.69 56.46 129.19 44.32 110.02 53.45C89.71 63.13 102.61 83.91 110.16 99.76",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M134.59 55.24C116.18 64.19 111.44 71.71 111.44 71.71L116.88 83.13L105.57 88.52L116.03 110.46C116.03 110.46 108.13 106.05 100.6 94.79C94.79 86.09 92.2 81 92.81 70.66C93.45 59.89 102.92 55.37 112.67 50.72C120.75 46.87 134.7 47.98 134.59 55.24Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M150.98 114.75L146.33 105",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M115.44 109.24L124.16 127.53",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M115.57 77.77L131.25 79.27L150.76 69.98L143.76 64.76C143.76 64.76 135.08 47.61 123.96 48.32C116.7 48.79 95.39 57.45 91.57 68.25C88.31 77.43 93.57 88.25 93.57 88.25L143.57 64.43",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M115.57 77.77L131.25 79.27L150.76 69.98L143.76 64.76C143.76 64.76 135.08 47.61 123.96 48.32C116.7 48.79 95.39 57.45 91.57 68.25C88.31 77.43 93.57 88.25 93.57 88.25L143.57 64.43",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M124.11 73.7L135.11 68.47C133.895 64.1003 131.929 59.9754 129.3 56.28C126.436 52.5389 123.35 48.9725 120.06 45.6L108.81 50.96C108.81 50.96 116.52 58.5 118.3 61.46C120.08 64.42 124.11 73.7 124.11 73.7Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M95.23 179.02C95.23 179.02 125.38 243.02 160.23 262.02L166.91 260.33C189.69 254.81 208.19 245.99 227.91 231.28L233.43 227.16L243.23 247.87L260.49 239.64C260.49 239.64 223.57 153.24 209.84 124.42C196.11 95.6 151.13 114.24 151.13 114.24L147.34 106.6C147.34 106.6 145.45 117.97 138.13 121.46C130.81 124.95 120.58 119.67 120.58 119.67L124.07 127.13C124.07 127.13 81.51 150.2 95.25 179.02",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M95.23 179.02C95.23 179.02 125.38 243.02 160.23 262.02L166.91 260.33C189.69 254.81 208.19 245.99 227.91 231.28L233.43 227.16L243.23 247.87L260.49 239.64C260.49 239.64 223.57 153.24 209.84 124.42C196.11 95.6 151.13 114.24 151.13 114.24L147.34 106.6C147.34 106.6 145.45 117.97 138.13 121.46C130.81 124.95 120.58 119.67 120.58 119.67L124.07 127.13C124.07 127.13 81.51 150.2 95.25 179.02",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M201.77 145.06L233.37 227.17L198.96 154.6L201.77 145.06Z",
    fill: "#D2D2D2"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M151.34 113.95C151.66 121.71 148.25 126.05 141.96 129.09L141.82 129.15C135.49 132.15 129.92 132.27 124.09 127.15",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M153.83 248.63C181.845 247.049 208.119 234.527 226.99 213.76",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M257.92 241.01L261.35 248.2L246.72 255.17L243.23 247.85L257.92 241.01Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M198.51 154.02L233.37 227.17",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M166.54 256.45V89.45C166.54 88.5378 166.72 87.6345 167.069 86.7919C167.419 85.9492 167.931 85.1837 168.576 84.5391C169.222 83.8945 169.988 83.3836 170.831 83.0354C171.674 82.6872 172.578 82.5087 173.49 82.51H378.11C379.026 82.5021 379.935 82.6757 380.784 83.0209C381.633 83.3661 382.405 83.8761 383.056 84.5213C383.707 85.1665 384.224 85.9343 384.576 86.7802C384.929 87.6262 385.11 88.5335 385.11 89.45V256.45H166.54Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M368.55 101.03H183.05V220.38H368.55V101.03Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M315.1 245.43V254.04H236V245.43H151.65V269.07H399.44V245.43H315.1Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M165.72 229.32L173.43 231.04L170.39 246.68L162.48 245.67L165.72 229.32Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M92.86 163.07C94.66 149.07 104.14 145.7 112.37 146.53C121.47 147.45 130.54 156.05 127.69 167.53L117.27 216.53L166.27 227.21L161.94 248.37L103.56 239.27C100.01 238.904 96.7346 237.196 94.402 234.495C92.0694 231.795 90.8561 228.305 91.01 224.74L92.86 163.07Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M250.15 74.53L241.41 82.18L250.15 87.42L253.9 97.86L264.1 97.22L268.53 88.19L262.37 74.53H250.15Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M130.65 108.25C135.864 108.666 141.091 107.627 145.75 105.25C153.96 101.13 151.87 88.32 144.28 72.39",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M130.65 108.25C135.864 108.666 141.091 107.627 145.75 105.25C153.96 101.13 151.87 88.32 144.28 72.39",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M195.16 219.14L173.78 261.38C173.559 261.867 173.438 262.393 173.424 262.927C173.409 263.462 173.503 263.994 173.697 264.491C173.892 264.989 174.185 265.443 174.558 265.826C174.931 266.208 175.377 266.513 175.87 266.72L178.33 267.8C179.315 268.23 180.431 268.251 181.432 267.859C182.433 267.467 183.238 266.694 183.67 265.71L202.59 222.38L220.37 215.38L218.37 199.76L210.63 190.48L210.17 205.02L203.04 207.87L201.04 192.25L193.16 203.55L195.16 219.14Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M173.43 231.04L184.5 227.75L190 229.32L187.92 233.44L197.16 234.79L198.96 231.27L200.32 237.39L197.75 246.68L186.82 251.15L170.39 246.68L173.43 231.04Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M274.9 120.55L235.34 189.15C235.165 189.454 235.072 189.799 235.072 190.149C235.072 190.5 235.164 190.845 235.34 191.149C235.515 191.453 235.767 191.706 236.071 191.881C236.374 192.057 236.719 192.15 237.07 192.15H316.24C316.591 192.15 316.936 192.057 317.239 191.881C317.543 191.706 317.795 191.453 317.97 191.149C318.146 190.845 318.238 190.5 318.238 190.149C318.238 189.799 318.145 189.454 317.97 189.15L278.34 120.55C278.163 120.252 277.911 120.004 277.61 119.833C277.308 119.661 276.967 119.571 276.62 119.571C276.273 119.571 275.932 119.661 275.63 119.833C275.329 120.004 275.077 120.252 274.9 120.55Z",
    fill: "#F0F0F0"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M406.98 225.16L419.42 266.66C419.42 266.66 422.74 268.21 425.36 267.42C427.98 266.63 429.91 263.52 429.91 263.52L417.47 222.01L406.98 225.16Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M397.1 173.11L412.22 223.58",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M278.63 146.25H274.63V170.25H278.63V146.25Z",
    fill: "#A9A9A9"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M278.63 174.27H274.63V178.27H278.63V174.27Z",
    fill: "#A9A9A9"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1 139.15H39.32L51.4 147.78V102.76H1V139.15Z",
    fill: "white",
    stroke: "#A9A9A9",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M32.98 119.71H8.74001",
    stroke: "#A9A9A9",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M32.98 127.99H8.74001",
    stroke: "#A9A9A9",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M32.98 111.43H8.74001",
    stroke: "#A9A9A9",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M415.8 28.38L413.43 17.84",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M431.99 100.34L429.62 89.8",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M422.58 90.59C439.96 90.59 454.05 76.5004 454.05 59.12C454.05 41.7396 439.96 27.65 422.58 27.65C405.2 27.65 391.11 41.7396 391.11 59.12C391.11 76.5004 405.2 90.59 422.58 90.59Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M422.58 71.84C429.605 71.84 435.3 66.1451 435.3 59.12C435.3 52.0949 429.605 46.4 422.58 46.4C415.555 46.4 409.86 52.0949 409.86 59.12C409.86 66.1451 415.555 71.84 422.58 71.84Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M453.27 52.12L463.8 49.72",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M381.36 68.53L391.89 66.12",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M439.63 32.47L445.41 23.35",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M400.19 94.8L405.97 85.67",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M449.34 75.75L458.48 81.5",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M386.89 36.5L396.03 42.25",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M382.18 13.85L387.22 10.96",
    stroke: "#A9A9A9",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M347.71 33.59L352.76 30.7",
    stroke: "#A9A9A9",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M367.43 39.16C376.791 39.16 384.38 31.5712 384.38 22.21C384.38 12.8488 376.791 5.26 367.43 5.26C358.069 5.26 350.48 12.8488 350.48 22.21C350.48 31.5712 358.069 39.16 367.43 39.16Z",
    fill: "white",
    stroke: "#A9A9A9",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M367.43 29.06C371.213 29.06 374.28 25.9932 374.28 22.21C374.28 18.4268 371.213 15.36 367.43 15.36C363.647 15.36 360.58 18.4268 360.58 22.21C360.58 25.9932 363.647 29.06 367.43 29.06Z",
    stroke: "#A9A9A9",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M375.9 36.89L378.8 41.93",
    stroke: "#A9A9A9",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M356.06 2.49L358.96 7.53",
    stroke: "#A9A9A9",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M383.85 26.76L389.46 28.29",
    stroke: "#A9A9A9",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M345.52 16.35L351.13 17.87",
    stroke: "#A9A9A9",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M363.11 38.62L361.61 44.23",
    stroke: "#A9A9A9",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M373.41 0.259998L371.9 5.88",
    stroke: "#A9A9A9",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9805_207545"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 464.02,
    height: 270.07,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintainanceMode);
export default __webpack_public_path__ + "static/media/maintainance_mode.549feb561e20d3f6e472b8f474a5fa8a.svg";
export { ForwardRef as ReactComponent };